import { AttendanceStatusTypes } from '../../domain/training.event.subscription';

export class UpdateTrainingEventSubscriptionStatusesRequest {
    TrainingEventSubscriptionID: number;
    NewStatus: AttendanceStatusTypes;
}

export class UpdateTrainingEventSubscriptionStatusesRequestArray extends Array<UpdateTrainingEventSubscriptionStatusesRequest> {

    constructor(...items: UpdateTrainingEventSubscriptionStatusesRequest[]) {
        super(...items);
        Object.setPrototypeOf(this, UpdateTrainingEventSubscriptionStatusesRequestArray.prototype);
    }
}
